import React from 'react'
import { Ratio } from 'react-bootstrap'
import styles from './index.module.css'
import { useDispatch,useSelector } from 'react-redux'
import { setPaletteS } from '../../store/modules/palette'
import { darkenColor } from '../../utils/publicfunction'

export default function Btnpalette() {
  const {c}=useSelector((state)=>state.palette);
  const {p}=useSelector((state)=>state.pencil);
  const pd= c===0 ? "" : styles.palettedown;
  const dn= !p||c===0 ? "d-none" : "";
  const dispatch=useDispatch();

  // 功能键背景色
  const {bm}=useSelector((state)=>state.colorplate);
  const darkenedColor = darkenColor(bm, 0.3);
  const buttonStyle = {
    backgroundColor: c===0 ? bm : darkenedColor
  };

  const settoc=()=>{
    let h=c;
    if(!p){
      h = h > 1 ? 1 : h;
      h=++h%2;
    }else{
      h=++h%6;
    }
    dispatch(setPaletteS(h));
  };
  
  return (
    <Ratio aspectRatio={"1x1"}>
    <div onClick={settoc}>
      <div
        className={`${styles.b_pa_adiv} ${pd}`}
        style={buttonStyle}
      >
        <img src='./pic/palette.svg' alt='' className={styles.b_pa_img}/>
        <img src='./pic/caret.svg' alt='' className={dn}/>
      </div>
    </div>
    </Ratio>
  )
}
